import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'ecp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  version = environment.appVersion;
}
